import React, { useRef, useState } from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import {
  Avatar,
  Box,
  ButtonBase,
  Divider,
  Hidden,
  Menu,
  MenuItem,
  Typography,
  makeStyles
} from '@material-ui/core';
import { logout } from 'src/actions/accountActions';
import { ROLES } from 'src/constants/roles';

const useStyles = makeStyles(theme => ({
  avatar: {
    height: 32,
    width: 32,
    marginRight: theme.spacing(1)
  },
  popover: {
    width: 200
  }
}));

function Account() {
  const { botId } = useParams();
  const classes = useStyles();
  const history = useHistory();
  const ref = useRef(null);
  const dispatch = useDispatch();
  const account = useSelector(state => state.account);
  const { enqueueSnackbar } = useSnackbar();
  const [isOpen, setOpen] = useState(false);
  const { t } = useTranslation('common');
  const showWorkspaceSwitcher =
    (account.user?.workspaces?.length || 0) > 1 ||
    account.user?.role === ROLES.superAdmin;

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = async () => {
    try {
      handleClose();
      await dispatch(logout());
      history.push('/');
    } catch (error) {
      enqueueSnackbar(t('unableLogout'), {
        variant: 'error'
      });
    }
  };

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        component={ButtonBase}
        onClick={handleOpen}
        ref={ref}
      >
        <Avatar
          alt="User"
          className={classes.avatar}
          src={account.user.avatar}
        />
        <Hidden smDown>
          <Typography variant="h6" color="inherit">
            {/* {`${account.user.username} `} */}
          </Typography>
        </Hidden>
      </Box>
      <Menu
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        keepMounted
        PaperProps={{ className: classes.popover }}
        getContentAnchorEl={null}
        anchorEl={ref.current}
        open={isOpen}
      >
        <Box p={2}>
          <Typography variant="h6" color="textPrimary">
            {account.user.username}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {account.user.email}
          </Typography>
        </Box>
        <Divider />
        <MenuItem component={RouterLink} to={`/studio/${botId}/profile`}>
          {t('profile')}
        </MenuItem>
        {account.user?.role === ROLES.superAdmin && (
          <MenuItem component={RouterLink} to='/super-admin'>
            {t('superAdminDashboard')}
          </MenuItem>
        )}
        {showWorkspaceSwitcher && (
          <MenuItem component={RouterLink} to='/workspaces'>
            {t('workspaces')}
          </MenuItem>
        )}
        <MenuItem onClick={handleLogout}>{t('logout')}</MenuItem>
      </Menu>
    </>
  );
}

export default Account;
